export interface CheckRegistrationResponse {
  success: boolean;
  isRegistered: boolean;
  userDetails?: {
    productId: string;
    organizationId: string;
    email: string;
    userId: string;
    firstName: string;
    lastName: string;
    userState: string;
    userType: string;
    activationStatus: string;
    profileStatus: string;
  };
  message?: string;
  error?: any;
}

const hostname = window.location.hostname;

export async function checkRegistration(
  userEmail: string
): Promise<CheckRegistrationResponse> {
  let baseurl = '';
  
  if (hostname.includes('localhost')) {
    baseurl = 'http://localhost:8080';
  } else if (hostname.includes('dev')) {
    baseurl = 'https://candidateinterviewscheduler-dev.pwc.com';
  } else if (hostname.includes('stg') || hostname.includes('stage')) {
    baseurl = 'https://candidateinterviewscheduler-stg.pwc.com';
  } else {
    baseurl = 'https://candidateinterviewscheduler.pwc.com';
  }

  const payload = { userEmail };

  const res = await fetch(`${baseurl}/api/candidate-dashboard/check-registration`, {
    method: 'POST',
    headers: { 
      'Accept': 'application/json', 
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload),
  });

  if (!res.ok) throw new Error(`Check registration failed: ${res.status} ${res.statusText}`);
  return res.json();
}